// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngMhsCOidIJI7d {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
.jBn4Di3CJHGMdE {
  display: flex;
  justify-content: center;
}
.vnck7Rwt9dTFeX {
  flex: 1 1 auto;
  min-height: calc(100vh - 80px);
  padding-bottom: var(--ds-space-400, 32px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.MIdVjYiqVhIdgk {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-400, 32px);
}
.DKWdoZrTd0TpSo {
  font-style: italic;
}
.MF9xCJFMaPPUsY {
  flex-grow: 1;
  min-width: 320px;
  max-width: 800px;
  padding: var(--ds-space-400, 32px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
}
.GLNxpvw5wdHPro {
  display: flex;
  align-items: center;
  justify-content: center;
}
.pRJvNX9_HTrh1V {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--ds-space-300, 24px);
  padding-bottom: var(--ds-space-200, 16px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.pRJvNX9_HTrh1V .ZZY6Ie_6FChb6b {
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.dH5mX66F9rEdQM {
  padding-top: var(--ds-space-200, 16px);
  border-top: 1px solid var(--ds-border, #091e4224);
}
.dH5mX66F9rEdQM button {
  margin-left: var(--ds-space-100, 8px);
}
.R91rKmpYJwNegr {
  display: flex;
  justify-content: flex-end;
}
@media only screen and (max-width: 900px) {
  .MF9xCJFMaPPUsY {
    padding: var(--ds-space-200, 16px);
  }
}
.czj9twzQ5sy2ub {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.Y2mmHKlBX3gUli {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 462px;
  min-height: 180px;
  margin: 10px var(--ds-space-0, 0) 10px var(--ds-space-0, 0);
  padding-bottom: 10px;
  border-bottom: 1px solid var(--ds-border, rgba(9, 30, 66, 0.0784314));
  text-align: center;
}
.RavUbMwx3fl_n_ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--ds-background-discovery, #f3f0ff);
}
.DkQdWV8ql3npsC {
  margin: var(--ds-space-025, 2px) var(--ds-space-0, 0) var(--ds-space-0, 0) 10px;
}
.z6xsM8iSk2wLKE {
  margin-top: 5px;
}
.lRqIMNC4Ecksko {
  margin: 15px var(--ds-space-0, 0) 15px var(--ds-space-0, 0);
  color: var(--ds-text-subtle, #44546f);
  text-align: center;
}
.bk13A01gLdT1mM {
  display: block;
  width: 275px;
  color: var(--ds-text-danger, #ae2a19);
  font-size: 12px;
}
.mEViWBu1sZkPah input {
  /* stylelint-disable-next-line declaration-no-important */
  width: 275px !important;
  height: 32px;
}
.AJZuskCGd_sVZz {
  /* stylelint-disable-next-line declaration-no-important */
  max-width: 600px !important;
  height: 384px;
  padding: var(--ds-space-250, 20px) var(--ds-space-300, 24px);
  background-color: var(--ds-surface, #ffffff);
}
@media only screen and (max-width: 900px) {
  .z6xsM8iSk2wLKE {
    width: 320px;
  }
  .mEViWBu1sZkPah label div:nth-child(2) {
    flex-direction: column;
  }
  .mEViWBu1sZkPah input {
    /* stylelint-disable-next-line declaration-no-important */
    width: 100% !important;
    height: 32px;
  }
  .DkQdWV8ql3npsC,
  .qhSJnWmOEWd5ju {
    width: 100%;
    height: 32px;
  }
  .DkQdWV8ql3npsC {
    margin: var(--ds-space-200, 16px) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0);
  }
  .qhSJnWmOEWd5ju {
    margin-bottom: 30px;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexRowWrap": `ngMhsCOidIJI7d`,
	"flexAndCenter": `jBn4Di3CJHGMdE`,
	"body": `vnck7Rwt9dTFeX`,
	"navigationAndContent": `MIdVjYiqVhIdgk`,
	"learnMoreSubtle": `DKWdoZrTd0TpSo`,
	"content": `MF9xCJFMaPPUsY`,
	"spinnerContainer": `GLNxpvw5wdHPro`,
	"header": `pRJvNX9_HTrh1V`,
	"title": `ZZY6Ie_6FChb6b`,
	"footer": `dH5mX66F9rEdQM`,
	"formFooter": `R91rKmpYJwNegr`,
	"generate": `czj9twzQ5sy2ub`,
	"generateInfo": `Y2mmHKlBX3gUli`,
	"iconKey": `RavUbMwx3fl_n_`,
	"submitBtn": `DkQdWV8ql3npsC`,
	"input": `z6xsM8iSk2wLKE`,
	"optionSeparator": `lRqIMNC4Ecksko`,
	"isInvalidApiKey": `bk13A01gLdT1mM`,
	"textfield": `mEViWBu1sZkPah`,
	"dialog": `AJZuskCGd_sVZz`,
	"generateBtn": `qhSJnWmOEWd5ju`
};
export default ___CSS_LOADER_EXPORT___;
